module.exports = __webpack_public_path__ + "static/media/trash-restore.979d873e.svg";